module.exports = __webpack_public_path__ + "img/pudongxinqu1.fc910899.png";